import { useEffect } from "react"
import { OverlayToaster, Position } from "@blueprintjs/core"
import { createRoot } from "react-dom/client"

export const useMapToaster = (mapContainer: HTMLElement | null | undefined) => {
  useEffect(() => {
    const createMapToaster = async () => {
      if (mapContainer) {
        window.mapToaster = await OverlayToaster.createAsync(
          {
            position: Position.TOP,
            usePortal: false,
          },
          {
            domRenderer: (toaster, containerElement) =>
              createRoot(containerElement).render(toaster),
            container: mapContainer,
          },
        )
      }
    }

    createMapToaster()

    return () => {
      window.mapToaster = undefined
    }
  }, [mapContainer])
}
